<template>
  <div class="home">
    <div class="banner" v-if="!userInfo">
      <div class="content-wrapper">
        <div class="banner-content">
          <div class="download-button">
            <router-link to="/download">下载 在艺App</router-link>
          </div>
          <div class="qr-code"></div>
        </div>
        <div class="login-box">
          <Login></Login>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="section" v-if="tickets.length">
        <div class="hd">
          <h2>特惠购票</h2>
          <div class="aside">
            <span class="more">
              <router-link to="/ticket">更多</router-link>
            </span>
          </div>
        </div>
        <div class="bd">
          <div class="ex-list">
            <ticketList :datas="tickets"></ticketList>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="hd">
          <h2>全球精选展览</h2>
          <div class="aside">
            <span class="more">
              <router-link to="/exhibition">更多</router-link>
            </span>
          </div>
        </div>
        <div class="bd">
          <div class="ex-list">
            <exhibitionList :datas="exhibitions"></exhibitionList>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="hd">
          <h2>热门艺术笔记</h2>
          <div class="aside">
            <span class="more">
              <router-link to="/notes">更多</router-link>
            </span>
          </div>
        </div>
        <div class="bd hot-notes">
          <notesList :data="notes"></notesList>
          <div class="notes-more">
            <router-link to="/notes">
              <span class="icon-notes-more"></span>
            </router-link>
          </div>
        </div>
      </div>
      <app-partner></app-partner>
    </div>
    <app-about></app-about>
  </div>
</template>
<script>
import Login from '../member/login'
import Partner from '../common/partner'
import About from '../common/about'
import ticketList from '../common/ticketList'
import exhibitionList from '../common/exhibitionList'
import notesList from '../common/notesList'

import { getExhibitionList, getNoteList, getTicketList } from '@/api/zaiart'

export default {
  components: {
    'app-partner': Partner,
    'app-about': About,
    ticketList,
    exhibitionList,
    notesList,
    Login
  },
  data() {
    return {
      userInfo: null,
      exhibitions: [],
      notes: [],
      tickets: []
    }
  },
  methods: {
    // 初始化
    init() {
      this.getTickets()
      this.getExhibtions()
      this.getNotes()
    },
    // 获取购票数据
    getTickets() {
      const param = { page: { index: 1, size: 10 } }
      return getTicketList(param).then(response => {
        this.tickets = response.data.list
      })
    },
    // 获取展览数据
    getExhibtions() {
      const param = { page: { index: 1, size: 10 } }
      return getExhibitionList(param).then(response => {
        this.exhibitions = response.data.list
      })
    },
    // 获取笔记数据
    getNotes() {
      const param = { page: { index: 1, size: 20 } }
      return getNoteList(param).then(response => {
        this.notes = response.data.list
      })
    }
  },
  created() {
    this.userInfo =
      (localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo'))) ||
      null
    this.init()
  }
}
</script>
<style scoped>
.banner {
  position: relative;
  height: 320px;
  background-color: #e5eef7;
}
.banner .banner-content {
  position: relative;
  padding-left: 320px;
  height: 320px;
  background: url('../../../assets/img/zaiart/banner.png') no-repeat;
  background-size: auto 100%;
}
.banner .banner-content .download-button {
  position: absolute;
  bottom: 42px;
  width: 152px;
  height: 38px;
  line-height: 38px;
  color: #fff;
  text-align: center;
  background: rgba(6, 80, 255, 0.9);
  border-radius: 19px;
}
.banner .banner-content .download-button a {
  display: block;
  height: 100%;
}
.banner .banner-content .qr-code {
  position: absolute;
  margin-left: 166px;
  top: 237px;
  width: 45px;
  height: 45px;
  background: url('../../../assets/img/icon/banner_qrcode.png') no-repeat;
  background-size: contain;
  cursor: pointer;
  z-index: 2;
}
.banner .banner-content .qr-code:hover {
  margin-left: 156px;
  top: 230px;
  width: 154px;
  height: 176px;
  background: url('../../../assets/img/icon/banner_qrcode_hover.png') no-repeat;
  background-size: contain;
  cursor: none;
}
.login-box {
  position: absolute;
  top: 0;
  right: 0;
  padding-top: 24px;
}
.section {
  clear: both;
  margin-top: 30px;
}
.section .hd {
  height: 48px;
}
.section .hd h2 {
  float: left;
  font-size: 24px;
  font-weight: normal;
  line-height: 48px;
  color: #1e1e1e;
}
.section .hd .aside {
  float: right;
}
.section .hd .aside .more {
  font-size: 20px;
  line-height: 48px;
  color: #0650ff;
}
.section .bd {
  clear: both;
  margin-top: 30px;
}
.hot-notes {
  position: relative;
  max-height: 886px;
  overflow: hidden;
}
.notes-more {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 60px;
  text-align: center;
  background-color: #fff;
  border-top: 1px solid #dadada;
}
.icon-notes-more {
  display: inline-block;
  margin-top: -21px;
  width: 42px;
  height: 42px;
  background: url('../../../assets/img/icon/circle-down.png') no-repeat;
  background-size: 100%;
}
</style>
